import { useState } from 'react';
import DashboardTable from "/src/features/plugins/dashboard/components/DashboardTable/DashboardTable";
import DashboardSharedTable from "/src/features/plugins/dashboard/components/DashboardTable/DashboardSharedTable";
import { PageTable, Header } from '/src/layouts/page';
import SliderTab from "/src/components/slider/sliderTab/SliderTab";
function DashboardList() {
    const [selectedComponent, setSelectedComponent] = useState(0);

    const handleButtonClick = (componentNumber) => {
        setSelectedComponent(componentNumber);
    };

    const items =  [
        {name : 'Tailored', component : <DashboardTable/>},
        {name : 'Plug-and-Play', component : <DashboardSharedTable/>},
    ]
    return (
        <PageTable>
            <Header title="List of Dashboards"></Header>
            <SliderTab items={items}></SliderTab>
        </PageTable>
    );
}

export default DashboardList;